const defaultGrnHeader = {
  'Material Document': 'pod_no',
  'Del. Note Quantity': 'deliver_quantity',
  Reference: 'delivery_no',
  Material: 'material_code',
};

module.exports = { defaultGrnHeader };
